import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IAppConfig } from '@warema/shared/models';
import { CountryService } from '@warema/shared/services';
import { WaremaIcon } from '@warema/warema-ui-angular';
import { CountryIsoPipe } from '../country-name.pipe';

@Component({
    selector: 'warema-country-menu',
    templateUrl: './country-menu.component.html',
    styleUrls: ['./country-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, CountryIsoPipe, WaremaIcon],
})
export class CountryMenuComponent {
    private readonly _countryService = inject(CountryService);

    public readonly appConfiguration = input.required<IAppConfig>();

    public readonly loggedIn = input.required<boolean>();

    public onCountryMenuSelectionClick(): void {
        if (this.loggedIn()) {
            return;
        }

        const appConfiguration = this.appConfiguration();
        if (!appConfiguration) {
            return;
        }

        const { countryConfigMap, country } = appConfiguration;
        const countryConfig = countryConfigMap.get(country);

        if (!countryConfig) {
            return;
        }

        const possibleCountries = Array.from(countryConfigMap.values());
        void this._countryService.openCountrySelectionDialog(possibleCountries, countryConfig.ISOCode);
    }
}
